export {default as ClaimTypeFormCard} from './ClaimType/ClaimTypeFormCard';
export {default as NewArtistFormCard} from './Artist/NewArtistFormCard';
export {default as ArtistSocialFormCard} from './Artist/ArtistSocialFormCard';
export {default as NewProviderFormCard} from './Provider/NewProviderFormCard';
export {default as ManagerArtistListFormCard} from './Manager/ManagerArtistListFormCard';
export {default as AddEditManagerArtistFormCard} from './Manager/AddEditManagerArtistFormCard';
export {default as LabelListFormCard} from './Label/LabelListFormCard';
export {default as AddEditLabelFormCard} from './Label/AddEditLabelFormCard';
